import React from 'react';
import {useTheme} from '@components/theme/useTheme';

interface ThemeAwareBadgeProps {
    className?: string;
    children: React.ReactNode;
}

const lightStyles =
    'bg-white/90 text-neutral-900 shadow-sm ring-1 ring-black/15 backdrop-blur-sm';
const darkStyles =
    'bg-neutral-950/85 text-white shadow-sm ring-1 ring-white/25 backdrop-blur-sm';

export const ThemeAwareBadge: React.FC<ThemeAwareBadgeProps> = ({
    className = '',
    children,
}) => {
    const theme = useTheme();
    const themeClass = theme === 'light' ? lightStyles : darkStyles;
    return (
        <span className={`badge ${themeClass} ${className}`.trim()}>
            {children}
        </span>
    );
};
